import styled from "styled-components";

export const ModalHolder = styled.div`
  top: 0;
  right: 0;
  position: absolute;
  width: 100%;
  height: 100%;
`;